import React from "react";
import { delayNavigation } from "../helpers/helpers";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const greenHomeFloors = [
  {
    number: 2,
    d: "M-20,1202 L80,1215 L1285,1195 L1570,1213 L1655,1208 L1801,1199 L1801,1194 L1825,1194 L1823,1110 L1647,1115 L1570,1118 L1285,1107 L80,1110 L-22,1105 Z",
  },
  {
    number: 3,
    d: "M-22,1105 L80,1110 L1285,1107 L1570,1119 L1647,1115 L1823,1110 L1818,1018 L1635,1022 L1590,1017 L1480,1017 L1285,1017 L80,1002 L-22,1010 Z",
  },
  {
    number: 4,
    d: "M-22,1010 L80,1002 L1285,1017 L1480,1017 L1635,1022 L1818,1018 L1816,925 L1656,927 L1593,924 L1480,924 L1286,934 L1246,934 L1246,928 L80,896 L-22,918 Z",
  },
  {
    number: 5,
    d: "M-22,918 L80,896 L1246,928 L1246,934 L1286,934 L1448,923 L1480,924 L1593,924 L1656,927 L1816,925 L1811,833 L1655,828 L1628,831 L1594,831 L1480,830 L1448,830 L1288,847 L1243,847 L1243,839 L80,791 L-22,824 Z",
  },
  {
    number: 6,
    d: "M-22,824 L80,791 L1243,839 L1243,847 L1288,847 L1448,830 L1480,830 L1594,831 L1628,831 L1655,828 L1811,833 L1815,742 L1655,733 L1634,738 L1592,737 L1479,734 L1449,737 L1289,762 L1242,762 L1242,750 L80,685 L-22,732 Z",
  },
  {
    number: 7,
    d: "M-22,732 L80,685 L1242,750 L1242,762 L1289,762 L1449,737 L1479,734 L1592,737 L1634,738 L1655,733 L1815,742 L1819,649 L1655,637 L1636,640 L1592,645 L1479,638 L1449,642 L1289,672 L1242,673 L1242,661 L80,580 L-22,637 Z",
  },
  {
    number: 8,
    d: "M-22,543 L90,475 L1243,572 L1243,588 L1289,588 L1449,550 L1479,544 L1592,553 L1642,548 L1659,543 L1823,557 L1819,649 L1655,637 L1636,640 L1592,645 L1479,638 L1449,642 L1289,672 L1242,673 L1242,661 L80,580 L-22,637 Z",
  },
  {
    number: 9,
    d: "M-22,543 L90,475 L1243,572 L1243,588 L1289,588 L1449,550 L1479,544 L1592,553 L1642,548 L1659,543 L1823,557 L1827,465 L1660,448 L1645,452 L1594,461 L1484,450 L1449,457 L1289,498 L1242,498 L1242,484 L90,370 L-22,449",
  },
  {
    number: 10,
    d: "M-22,449 L90,370 L1242,484 L1242,498 L1289,498 L1449,457 L1484,450 L1594,461 L1645,452 L1660,448 L1827,465 L1831,363 L1824,361 L1806,367 L1808,288 L1648,267 L1502,315 L1502,350 L1372,388 L1282,382 L1262,389 L1220,384 L1220,372 L78,239 L-22,329 Z",
  },
];
const nikeaFloors = [
  {
    number: 3,
    d: "M125,1415 L844,1420 L865,1405 L1025,1405  L1225,1405 L1862,1405   L1862,1300 L1025,1300 L1025,1320 L860,1320 L842,1308 L125,1310 Z",
  },
  {
    number: 4,
    d: "M125,1310 L842,1308 L860,1320 L1025,1320 L1025,1300 L1862,1300 L1862,1190 L1226,1190 L1226,1195 L1026,1195 L1026,1225 L862,1225 L843,1192 L125,1190 Z",
  },
  {
    number: 5,
    d: "M125,1190 L843,1192 L862,1225 L1026,1225 L1026,1195 L1226,1195 L1226,1190 L1862,1190  L1862,1030 L1226,1030 L1226,1090 L1025,1090 L1025,1125 L862,1125 L843,1082 L125,1082 Z",
  },
  {
    number: 6,
    d: "M125,1082 L843,1082 L862,1125 L1025,1125 L1025,1090 L1226,1090 L1226,1030 L1660,1030 L1660,1020 L1692,993 L1692,989 L1699,985 L1699,978 L1025,978 L1025,1028 L860,1028 L845,973 L125,973 Z",
  },
  {
    number: 7,
    d: "M125,973 L845,973 L860,1028 L1025,1028 L1025,978 L1703,978 L1703,872 L1025,872 L1025,930 L862,930 L862,930 L842,863 L125,865",
  },
  {
    number: 8,
    d: "M125,865 L842,863 L862,930 L862,930 L1025,930 L1025,872 L1703,872 L1703,764 L1025,764 L1025,832 L862,832 L842,755 L125,755 Z",
  },
  {
    number: 9,
    d: "M125,755 L842,755 L862,832 L1025,832 L1025,764 L1703,764 L1703,660 L1025,660 L1025,734 L862,734 L842,644 L125,646 Z",
  },
  {
    number: 10,
    d: "M125,646 L842,644 L862,734 L1025,734 L1025,660 L1703,660 L1703,552 L1025,552 L1025,634 L862,634 L842,532 L125,532 Z",
  },
  {
    number: 11,
    d: "M125,532 L842,532 L862,634 L1025,634 L1025,557 L1703,552 L1703,445 L1025,452 L1025,542 L862,542 L842,423 L125,426 Z",
  },
  {
    number: 12,
    d: "M121,426 L842,423 L862,542 L1025,542 L1025,452 L1703,445 L1703,287 L1025,287 L1025,390 L862,390 L842,232 L121,234 Z",
  },
];

const VisualSearchPaths = ({
  project,
  hoveredFloor,
  floorIsSold,
  setHoveredFloor,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const floors =
    project === "greenhome"
      ? greenHomeFloors
      : project === "nikea"
      ? nikeaFloors
      : [];

  if (floors.length === 0) return null;

  return (
    <svg
      className="absolute top-0 left-0 w-full h-full pointer-events-none"
      viewBox="0 0 2000 2000"
      xmlns="http://www.w3.org/2000/svg"
    >
      {floors.map(({ number, d }) => (
        <path
          key={number}
          d={d}
          fill={
            hoveredFloor === number
              ? floorIsSold
                ? "rgba(255,61,0, 0.5)"
                : "rgba(210, 242, 155, 0.5)"
              : "transparent"
          }
          stroke="red"
          strokeWidth="0"
          className={`${
            floorIsSold ? "cursor-not-allowed" : "cursor-pointer"
          } pointer-events-auto transition-all duration-300`}
          onMouseEnter={() => setHoveredFloor(number)}
          onMouseLeave={() => setHoveredFloor(null)}
          onClick={() => {
            if (!floorIsSold) {
              delayNavigation(
                dispatch,
                navigate,
                `/projects/${project}/block/floor/${number}`
              );
            }
          }}
        />
      ))}
    </svg>
  );
};

export default VisualSearchPaths;
